export default __webpack_public_path__ + "static/fraud-prevention-bg-img-0004cb57e5e9507946a7c9cf393b13c6.png";